import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      toast.error(t("auth.missingSession"));
      nav("/login");
      return;
    }
    const sid = m[1];
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        localStorage.setItem("hg_token", data.token);
        setUser(data.user);
        toast.success(t("auth.welcomeBack") + ", " + data.user.name + "!");
        const dest = data.user.role === "admin" ? "/admin" : data.user.role === "worker" ? "/worker" : "/dashboard";
        nav(dest, { replace: true });
      })
      .catch(() => {
        toast.error(t("auth.googleSignInFailed"));
        nav("/login", { replace: true });
      });
  }, [nav, setUser, t]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
      <div className="text-center">
        <Loader2 className="animate-spin mx-auto text-[#1C4532]" size={28}/>
        <p className="mt-4 text-sm text-[#646964] tracking-wide uppercase font-bold">{t("auth.signingIn")}</p>
      </div>
    </div>
  );
}
